import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "h-screen" }
const _hoisted_3 = { class: "flex bg-neutral-200 dark:bg-neutral-700 border border-neutral-300 dark:border-neutral-700 rounded shadow-lg h-full" }
const _hoisted_4 = { class: "absolute top-0 h-10 w-full z-10" }
const _hoisted_5 = { class: "flex items-center space-x-2 p-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-black dark:text-neutral-300 text-xs font-medium" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "flex space-x-1 items-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs dark:text-neutral-300" }, " Conectando ... ", -1)
const _hoisted_9 = { class: "flex items-center space-x-1 pr-1" }

import { ref, computed, watch, onMounted } from 'vue'
    import { useElementSize, useDraggable } from '@vueuse/core'
    import Icon from '@/components/Icon/IndexIcon.vue'
    import HomeChart from '@/components/WebChatInternal/HomeChart.vue'
    import PreviewLoading from '@/components/Utils/PreviewLoading.vue'
    import useMoveInterface from '@/hooks/useMoveInterface'
    import useWebSocketChat from '@/hooks/useWebSocketChat'
    import useToggleTheme from '@/hooks/useToggleTheme'

    // import { getWidthWindow, getHeightWindow } from '@/helpers/interface'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BoxInternChat',
  props: {
        bgColor: {
            type: String,
            default: '#000'
        },
        right: {
            type: String,
            default: '20'
        }
    },
  emits: ['close-box', 'external-box'],
  setup(__props, { emit }) {

    

    

    const el = ref<HTMLDivElement | null>(null)
    const box = ref<HTMLElement | null>(null)
    const isMobile = ref<boolean>(false)
    const isOpen = ref<boolean>(true)

    const { status } = useWebSocketChat()
    const { themeDark } = useToggleTheme()
    const { width } = useElementSize(el)
    const { getBox } = useMoveInterface()

    const IconColor = computed(() => (themeDark() ? 'white' : 'black'))
    const positionForClick = computed(() => getBox())
    const { x, y } = useDraggable(el, { initialValue: { x: positionForClick.value.x, y: positionForClick.value.y } })

    function initialize(): void {
        x.value = positionForClick.value.x
        y.value = positionForClick.value.y
    }



    watch(() => width.value, newValue => {
        isMobile.value = newValue < 550
    })
    /*
    watch(() => status.value, () => {
        if (status.value !== 'OPEN') {
            console.log('BLOQUEAR TELA')
        }
    })

    watch(() => x.value, newValue => {
        console.log(x.value)
        if(newValue < 0) x.value = 1
        if((newValue + 64) > getWidthWindow()) x.value = getWidthWindow() - 65
    })

    watch(() => y.value, newValue => {
        console.log(y.value)
        if(newValue < 0) y.value = 1
        if((newValue) > getWidthWindow()) y.value = getHeightWindow() - 65
    })
    */

    onMounted(() => {
        initialize()
        setTimeout(() => isOpen.value= false, 500)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            ref_key: "el",
            ref: el,
            class: "flex flex-col w-full h-full rounded-r-md relative"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "flex bg-neutral-200 dark:bg-neutral-800 h-full border-b px-2 pt-3 pb-2 border-neutral-300 dark:border-neutral-700 justify-between",
                ref_key: "box",
                ref: box
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(Icon, {
                    size: "14",
                    name: "Chat",
                    color: _unref(IconColor)
                  }, null, 8, ["color"]),
                  _hoisted_6
                ]),
                (_unref(status) !== 'OPEN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(Icon, {
                        size: "14",
                        name: "LoadingCircle",
                        color: _unref(IconColor)
                      }, null, 8, ["color"]),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('external-box'))),
                    class: "text-white flex justify-end mr-1 cursor-pointer",
                    title: "Abrir outra página"
                  }, [
                    _createVNode(Icon, {
                      size: "16",
                      name: "ExternalLink",
                      color: _unref(IconColor)
                    }, null, 8, ["color"])
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close-box'))),
                    class: "text-white flex justify-end mr-1 cursor-pointer p-1",
                    title: "Fechar"
                  }, [
                    _createVNode(Icon, {
                      size: "12",
                      name: "close",
                      color: _unref(IconColor)
                    }, null, 8, ["color"])
                  ])
                ])
              ], 512)
            ]),
            _createVNode(HomeChart, { mobile: isMobile.value }, null, 8, ["mobile"])
          ], 512)
        ])
      ]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(PreviewLoading, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})